import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import bgImg from '../assets/images/opening-bg.png';
import titleImg from '../assets/images/title-logo.png';
import { withUrlValidation } from '../components/withUrlValidation';
import { validateUrlParams } from '../utils/urlParamUtils';
import { trackQREntry } from '../utils/funnelDataUtils';

const Background = styled.div`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  min-height: 100dvh;
  background: url(${bgImg}) center/cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const TitleImage = styled.img<{ visible: number }>`
  width: 70dvw;
  max-width: 85dvw;
  margin-bottom: 5dvh;
  opacity: ${({ visible }) => visible};
  transition: opacity 0.5s ease;
`;

const OpeningPage = () => {
  const [visible, setVisible] = useState(0); // 0: 투명, 1: 보임
  const navigate = useNavigate();
  const location = useLocation();
  const [pageStartTime] = useState(Date.now());

  useEffect(() => {
    // URL 파라미터가 있으면 세션에 저장
    const searchParams = new URLSearchParams(location.search);
    const hasParams = searchParams.has('t') && searchParams.has('h');
    
    
    // 페이지 진입 추적
    const entryType = hasParams ? 'preshow_qr' : 'direct';
    
    
    if (entryType === 'preshow_qr') {
      // 퍼널 데이터에 프리쇼 QR 진입 추적
      trackQREntry();
    }
    
    if (hasParams) {
      // URL 파라미터 검증 (세션 저장 없이)
      validateUrlParams(searchParams).catch((error: Error) => {
        console.error('OpeningPage: URL 파라미터 검증 실패:', error);
      });
    }

    // 페이드인
    const fadeIn = setTimeout(() => setVisible(1), 100);
    // 페이드아웃
    const fadeOut = setTimeout(() => setVisible(0), 1000);
    // 페이지 이동 (세션 파라미터와 함께)
    const move = setTimeout(() => {
      // 세션 데이터가 있으면 세션 파라미터와 함께, 없으면 일반 이동
      if (hasParams) {
        // 세션 파라미터를 URL에 추가하여 이동
        const urlWithParams = `/guide01?t=${searchParams.get('t')}&h=${searchParams.get('h')}`;
        navigate(urlWithParams);
      } else {
        navigate('/guide01');
      }
    }, 1500);
    return () => {
      clearTimeout(fadeIn);
      clearTimeout(fadeOut);
      clearTimeout(move);
    };
  }, [navigate, location.search]); // navigateWithSession 제거, navigate 추가

  return (
    <Background>
      <TitleImage src={titleImg} alt="타이틀" visible={visible} />
    </Background>
  );
};

export default withUrlValidation(OpeningPage, {
  requireValidation: true, // URL 검증 필요
  showCountdown: true
}); 